/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Novelist API
 * Admin REST API
 * OpenAPI spec version: 10b70efd47036b72e8d1dec5d12405f81f712e3a
 */

/**
 * Controls how a section is presented in the client.
 */
export type DisplayMode = typeof DisplayMode[keyof typeof DisplayMode];


export const DisplayMode = {
  banner: 'banner',
  special: 'special',
  regular: 'regular',
} as const;
